__webpack_require__.p = "/digit-recognition/";